import { Injectable } from '@angular/core';
import { delay, Observable, of, shareReplay } from 'rxjs';
import { Profile } from '@core/profile';

@Injectable()
export class ProfileServiceMock {
  #profile$ = this.#getProfile().pipe(
    shareReplay(1),
  );

  profile$: Observable<Profile> = this.#profile$

  #getProfile(): Observable<Profile> {
    return of({
      google_id: '1',
      email: 'j.doe@email.com',
      picture: 'https://picsum.photos/200',
      first_name: 'John',
      last_name: 'Doe',
    }).pipe(delay(1000));
  }
}
